import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { isAppRoute } from 'routes/paths'
import { actionCreators as authActionCreators } from '@blocket/authentication-fe'
import biggAssCategoryPickerTracker from 'tracking/bigAssCategoryPicker'
import get from 'lodash/get'

import adWatchesCountPlugin from '@blazar-plugins/ad-watches-count'
import { withDevice } from '@blazar-plugins/device'

import { buildListUrl } from 'utils/url'
import Cookies from 'universal-cookie'
import { getRootDomain } from 'utils/domainName'

import { TabBar } from 'blocket-ui'
import messageCenterPlugin from '@blazar-plugins/message-center-count'
import getBigAssCategories from './bigAssCategoryPicker'
import getCurrentUrl from '../../utils/url'

const mapStateToProps = (state) => {
  const adsQuery = {
    ...state.geoPicker.geoPreference,
  }

  const adsUrl = buildListUrl(adsQuery, state.searchParams.byQueryKey)

  const bigAssCategories = getBigAssCategories(
    get(state, 'searchParams.byQueryKey', {}),
    get(state, 'geoPicker.geoPreference', {}),
  )

  return {
    userInfo: state.account.user,
    unreadMessagesCount: messageCenterPlugin.selectors.unreadCountSelector(state),
    adWatchesNewCount: adWatchesCountPlugin.selectors.adWatchesNewCountSelector(state),
    adsUrl,
    adInsertUrl: '/mina-annonser/lagg-in-annons',
    isAppRoute,
    bigAssCategories,
  }
}

export const onAdInsertClick = () => {
  const cookies = new Cookies()
  cookies.set('AdInsertCancelUrl', getCurrentUrl(), {
    path: '/',
    secure: false,
    httpOnly: false,
    maxAge: 60 * 60 * 24, // 24 hours
    domain: `.${getRootDomain(getCurrentUrl())}`,
  })
}

function mapDispatchToProps(dispatch, ownProps) {
  const redirectUrl = ownProps.location.pathname
  const cancelUrl = ownProps.location.pathname

  return {
    onLoginClick: (e) => {
      e.preventDefault()
      dispatch(authActionCreators.blocketLoginHelper.goToLogin(redirectUrl, cancelUrl, 'menu'))
    },
    onLogoutClick: (e) => {
      e.preventDefault()
      dispatch(authActionCreators.blocketLoginHelper.logout(redirectUrl))
    },
    onAdInsertClick: (e) => {
      onAdInsertClick(e)
    },
    trackBigAssCategoryClick: (categoryName) => {
      biggAssCategoryPickerTracker.clickEvents.trackCategoryLinkClick(categoryName)
    },
    trackBigAssCategoryOpenMenuClick: () => {
      biggAssCategoryPickerTracker.clickEvents.trackOpenMenuClick()
    },
  }
}

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(withDevice(TabBar)),
)
